module.exports = __webpack_public_path__ + "static/media/texture-season-5.07eb3871.jpg";